// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class ApiMemesMintStatsYearly {
    'year': number;
    'total_count': number;
    'mint_count': number;
    'subscriptions_count': number;
    'proceeds_eth': number;
    'proceeds_usd': number;
    'artist_split_eth': number;
    'artist_split_usd': number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "year",
            "baseName": "year",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "total_count",
            "baseName": "total_count",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "mint_count",
            "baseName": "mint_count",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "subscriptions_count",
            "baseName": "subscriptions_count",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "proceeds_eth",
            "baseName": "proceeds_eth",
            "type": "number",
            "format": "double"
        },
        {
            "name": "proceeds_usd",
            "baseName": "proceeds_usd",
            "type": "number",
            "format": "double"
        },
        {
            "name": "artist_split_eth",
            "baseName": "artist_split_eth",
            "type": "number",
            "format": "double"
        },
        {
            "name": "artist_split_usd",
            "baseName": "artist_split_usd",
            "type": "number",
            "format": "double"
        }    ];

    static getAttributeTypeMap() {
        return ApiMemesMintStatsYearly.attributeTypeMap;
    }

    public constructor() {
    }
}

